(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mb-card-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function start(root) {
      var cycle = parseInt(root.dataset.cycleMs, 10) || 1209600000;
      var anchor = parseInt(root.dataset.anchorMs, 10) || 0;
      var fixed = parseInt(root.dataset.deadlineMs, 10) || 0;

      var dEl = root.querySelector('[data-days]');
      var hEl = root.querySelector('[data-hours]');
      var mEl = root.querySelector('[data-minutes]');
      var sEl = root.querySelector('[data-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;

      function remaining() {
        var now = Date.now();
        // una scadenza dal metafield vince, ma solo se è ancora futura
        if (fixed > now) return fixed - now;
        var elapsed = now - anchor;
        if (elapsed < 0) return cycle;
        // finestra che si rigenera: quando finisce, riparte da sola
        return cycle - (elapsed % cycle);
      }

      function tick() {
        var diff = remaining();
        if (diff < 0) diff = 0;
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      var timer = setInterval(tick, 1000);
      root.addEventListener('mb-countdown:stop', function () {
        clearInterval(timer);
      });
    }

    function init() {
      document.querySelectorAll('.mb-countdown:not([data-cd-init])').forEach(function (el) {
        el.setAttribute('data-cd-init', '1');
        start(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // le sezioni ricaricate dall'editor o dal filtro collezione portano nuove schede
    document.addEventListener('shopify:section:load', init);
    if (window.MutationObserver) {
      new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
